import ApplicationLogo from '@/Components/ApplicationLogo'
import { useUsersRegistrationContext } from '@/context/UsersRegistration'
import { Link } from '@inertiajs/inertia-react'
import Cookies from 'js-cookie'
import React, { useEffect } from 'react'
import Swal from 'sweetalert2'

const OfficeSelector = ({ uuid, store, branchOffices, service, flash }) => {

    const { removeUsersRegistration } = useUsersRegistrationContext();

    useEffect(() => {
        if (flash?.status === 'branch-office.not-active') {
            Swal.fire({
                icon: 'warning',
                title: 'Lo sentimos',
                html: `<p>Esta sucursal ya no esta en funcionamiento, por favor contáctese a <a href="mailto:cerogrado@cerogrado.cl">cerogrado@cerogrado.cl</a></p>`,
            });
        }

        removeUsersRegistration();
        window.sessionStorage.removeItem('order_checkout_id');
        Cookies.remove('order_checkout_clients');
    }, [])


    return (
        <div className="bg-gray-100 h-screen">
            <div className="text-center">
                <ApplicationLogo className="mx-auto" store={store} />
                <div className="pb-20 pt-10">
                    <h1 className="text-lg">Ven a divertirte al mejor parque de patinaje de todo Chile.</h1>
                    <h2 className="text-2xl font-bold">Selecciona una sucursal para continuar.</h2>

                </div>
            </div>
            <div className="grid grid-cols-2 gap-5 max-w-2xl mx-auto">
                {
                    branchOffices &&
                    branchOffices.map((office, key) => (
                        <Link href={route('service.quantity-date-selector', {office: office.slug, uuid})} key={key} className="rounded-xl overflow-hidden text-center bg-white">
                            <img className="w-full" src={office.img} alt="" />
                            <div className="p-5">
                                <h3 className="text-xl font-bold">{office.name}</h3>
                                <p>{office.address}</p>
                            </div>
                        </Link>
                    ))
                }

            </div>
        </div>
    )
}

export default OfficeSelector
